var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"","fillRule":"evenodd","points":"6.852 7.649 .399 1.195 1.445 .149 7.899 6.602 14.352 .149 15.399 1.195 8.945 7.649 15.399 14.102 14.352 15.149 7.899 8.695 1.445 15.149 .399 14.102"}));
}

CloseInline.defaultProps = {"className":"svg-icon","aria-hidden":"true","role":"img","focusable":"false","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
